import React from 'react'
import ReactDOM from 'react-dom'
import App from 'App'
import {Provider} from 'react-redux'
import createStore from './createStore'
import rootSaga from 'sagas'
import {adminInit, initApi, getVersion} from 'utils/utils'
import 'css/icons.css'
import 'css/entity-icons.css'
import 'css/index.css'
import '../node_modules/react-grid-layout/css/styles.css'
import '../node_modules/react-resizable/css/styles.css'
import './global.js'

const store = createStore({})
store.runSaga(rootSaga)
adminInit()
console.log(`flClient initialized v${initApi()}`)
console.log(`flBusiness initialized v${getVersion()}`)

ReactDOM.render (
	<Provider store={store}>
		<App />
	</Provider>, document.getElementById('root')
)
